import { combineEpics } from 'redux-observable';
import { accountManagementEpics } from '../../features/accountManagement';
import mappingEpics from './tripEpics';

const epicRegistry = [...mappingEpics, ...accountManagementEpics];

export default combineEpics(...epicRegistry);
